import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  borderRadius: '8px',
  padding: theme.spacing(2),
  maxWidth: '100%',
  margin: '0 auto',
  width: '100%',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
  },
}));

export const MainContent = styled(Box)<{ sidebarOpen?: boolean }>(({ theme, sidebarOpen = true }) => ({
  position: 'relative',
  right: 0,
  top: 0,
  width: '100%',
  padding: theme.spacing(3),
  transition: 'all 0.3s ease',
  backgroundColor: '#E7EFF5',
  height: '100%',
  minHeight: 'calc(100vh - 72px)',
  maxHeight: '100%',
  overflowX: 'hidden',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  boxSizing: 'border-box',
  '& .MuiContainer-root': {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
    width: '100%',
    boxSizing: 'border-box',
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
}));

export const TableSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const TableTitle = styled(Box)(({ theme }) => ({
  fontSize: '1.2rem',
  fontWeight: 600,
  marginBottom: theme.spacing(2),
  padding: theme.spacing(1, 2),
  backgroundColor: '#f5f5f5',
  borderRadius: theme.shape.borderRadius,
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  height: '30px',
  borderRadius: '1000px',
  padding: '0 24px',
  fontSize: '11px',
  fontWeight: 600,
  textTransform: 'uppercase',
  minWidth: 'auto',
  boxShadow: 'none',
  '&.MuiButton-contained': {
    backgroundColor: '#00ACE7',
    color: '#FFFFFF',
    border: 'none',
    '&:hover': {
      backgroundColor: '#0095C7',
      boxShadow: 'none',
    },
    '&:disabled': {
      backgroundColor: '#B8C4CE',
      color: '#6C757D',
      boxShadow: 'none',
    },
  },
  '&.MuiButton-outlined': {
    backgroundColor: '#FFFFFF',
    color: '#00ACE7',
    border: '1px solid #00ACE7',
    '&:hover': {
      backgroundColor: '#F0F9FF',
      border: '1px solid #0095C7',
      boxShadow: 'none',
    },
    '&:disabled': {
      backgroundColor: '#F8F9FA',
      color: '#B8C4CE',
      border: '1px solid #B8C4CE',
      boxShadow: 'none',
    },
  },
})); 